<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Attainments"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <l-csv-import @on-import="onAttainments" />
    </l-container>

    <l-info-box
      class="mb-4"
      :active="attainments.length > 0"
    >Right click a row to edit, delete or add a new record</l-info-box>
    <hot-table :data="attainments" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="Name" data="name" read-only="true"></hot-column>
      <hot-column title="Assessment Regime ID" data="assessmentregime_id" read-only="true"></hot-column>
      <hot-column title="Comment" data="comment" read-only="true"></hot-column>
    </hot-table>

    <l-l-edit
      :showing="edit"
      @save="onSaveAttainments"
      @close="edit = false"
      :attainments="attainments"
      :assessmentregimes="assessmentregimes"
      :selected="selected"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import AttainmentsService from "./attainments.service";


import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";

import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";

export default {
  name: "attainments",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport
  },
  data() {
    return {
      edit: false,
      loading: false,
      attainments: [],
      assessmentregimes: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      isnew: false,
      selected: {}
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.attainments = await AttainmentsService.attainments();
      this.assessmentregimes = await AttainmentsService.assessmentregimes();
    },
    // async deleteAttainments(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await AttainmentsService.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         activeEditor.autoResize.unObserve = () => {};
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Attainments deleted!");
    //   }
    // },
    async saveAttainments(ra) {
      const rowsAffected = await AttainmentsService.update(ra);
          console.log("SAVED TO DB");
          const current = this.attainments.find(n => n.id == ra.id);
          for (var prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
              if (current[prop] != "id" && ra[prop]) {
                current[prop] = ra[prop];
              }
            }
          }
    },
    async importAssessmentMethods(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await AttainmentsService.importData(formData);
      this.attainments = await AttainmentsService.assessmentMethods();
      Notify.success("Assessment Methods imported!");
    },
    async onAssessmentMethods(file) {
      await Notify.loadData(
        "Importing Assessment Methods",
        this.importAssessmentMethods,
        file
      );
    },
    async importAttainments(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await AttainmentsService.import(formData);
      this.attainments = await AttainmentsService.attainments();
      Notify.success("Attainments imported!");
    },
    async onAttainments(file) {
      await Notify.loadData(
        "Importing Attainments",
        this.importAttainments,
        file
      );
    },
    onEditAttainments(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;

      var id = row.id;
      //var pollutantid = row.pollutant.substr(row.pollutant.lastIndexOf('/')+1);
      //var x  = AttainmentsService.aassessmentdata(101,5);
      //xassessmentdata  = AttainmentsService.aassessmentdata(id,pollutantid);

    },
    onNewAttainments(t, o) {  
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteAttainments(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              const rowsAffected = await AttainmentsService.delete(
                row.id
              );
              const activeEditor = hot.getActiveEditor();
              activeEditor.autoResize.unObserve = () => {};
              hot.alter("remove_row", clickedRow, 1);
            }
          );
          Notify.success("Attainments deleted!");
        }
      }, "This will delete all data connected to this Attainment. <br/><br/>Do you want to continue?");
    },

    async onSaveAttainments(attainments) {
      await Notify.loadData(
        "Saving changes to Attainments " + attainments.id,
        this.saveAttainments,
        attainments
      );
      this.selected = {};
      Notify.loadData(null, this.loadInitialData);
    }
  }
};
</script>



